import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { BuscadorColeccionistaService } from './buscador-coleccionista.service';
import { map, Observable, Subject } from 'rxjs';
import { Coleccionista, DataColeccionista } from 'app/models/coleccionitas.model';
import { FichaRegistro } from 'app/models/fichaRegistro.model';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'buscador-coleccionista',
    templateUrl: 'buscador-coleccionista.component.html',
    imports:[
        CommonModule,
        MatFormFieldModule,
        MatTableModule,
        FormsModule,
        MatAutocompleteModule,
        MatInputModule,
        MatIconModule,
        ReactiveFormsModule,
        MatButtonModule
    ]
})

export class BuscadorColeccionistaComponent implements OnInit {
    coleccionistaActual:Coleccionista
    listadoColeccionistas$:Observable<DataColeccionista[]>
    filteredColeccionista: any[] = [];
    @Input() ficha:FichaRegistro

    sinResultados: boolean = false;
    private destroy$ = new Subject<void>();
    

    @Output() coleccionistaSeleccionado = new EventEmitter<Coleccionista>

    searchControl: UntypedFormControl = new UntypedFormControl();

    constructor(
        private buscadorColeccionistaService: BuscadorColeccionistaService) {
        this.listadoColeccionistas$= this.buscadorColeccionistaService.coleccionistas$
    }

    ngOnInit() {
        this.buscadorColeccionistaService.limpiarColeccionistas();
    }

    onInputChange(){}

    BuscarColeccionista(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            const searchTerm = this.searchControl.value?.trim();
            if (searchTerm) {
                let params={ busqueda:searchTerm,  seccion: this.ficha.seccion.tipologiaId}
                this.buscadorColeccionistaService.getColeccionista(params)
                .then((response)=>{
                    this.listadoColeccionistas$.pipe(
                        map(listado => listado.length === 0)
                        ).subscribe(esPrimera => {
                        this.sinResultados = esPrimera;
                    });
                })
            }
        } 
    }

    seleccionarColeccionista(coleccionista:Coleccionista ){
        this.coleccionistaSeleccionado.emit(coleccionista)
        this.coleccionistaActual= coleccionista
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}